<template>
  <div id="app">
    <div id="nav" ref="navWrap">
      <router-link :to="{ name: 'home' }" class="lg:border-r-1 border-grey-darker lg:pr-24 flex items-center"><img class="logo" alt="logo" src="@/assets/logo_2026.svg" @load="logoLoaded"></router-link>
      <div class="nav-wrap">
        <div class="nav--left">
          <div class="nav__menu py-8" :class="{'active': isMenu}" @click="menuOpenHandler" v-click-outside="menuCloseHandler" ref="nav_menu_btn">
            <i class="owl-grid-three-h"></i>
            <span class="hidden md:inline">{{ $t('nav.industries') }}</span>
            <div class="nav__menu__list" v-if="isMenu" :style="menuPosition">
              <template v-for="(industry, index) in industries">
                <div v-if="!industry.hide" class="nav__menu__list__item" :key="index">
                  <router-link v-if="industry.active && industry.routername && industry.routername.name && !industry.specificPage" :to="{name: 'industry', params: { industry: industry.routername.name} }" @click.native="menuCloseHandler">{{ industry.title | i18n(industry.name) }}</router-link>
                  <router-link v-else-if="industry.active && industry.routername && industry.routername.name && industry.specificPage" :to="{ name: industry.specificPage }" @click.native="menuCloseHandler">{{ industry.title | i18n(industry.name) }}</router-link>
                  <a v-else disabled>{{ industry.title | i18n(industry.name) }}</a>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="nav--right">
          <div class="hidden md:block mr-16 border-r-1 border-grey-darker pr-16">
            <multiSelect
              class="languageSelect cursor-pointer"
              v-model="changeLanguage"
              :options="languageOptions"
              :searchable="false"
              :show-labels="false">
              <template slot="option" slot-scope="{ option }">
                {{ option.name }}
              </template>
              <template slot="singleLabel" slot-scope="{ option }">
                <i class="owl-earth mr-8"></i>
                <span class="text-md">{{ option.name }}</span>
              </template>
            </multiSelect>
          </div>
          <!-- <span class="text-white border-r-1 border-grey-dark pr-16 mr-8 inline-block hidden sm:block pointer-events-none">{{ $t('nav.contactUs') }}</span> -->
          <a href="tel:+886-2-6610-0180" target="_blank" class="link"><i class="owl-phone" /></a>
          <span class="link" :class="{ 'actived': isContactForm}" @click="openContactForm"><i class="owl-format-mail"/></span>
        </div>
      </div>
    </div>
    <div class="text-right bg-indigo-darkest text-white block md:hidden">
      <span>
        <multiSelect
          class="languageSelect"
          v-model="changeLanguage"
          :options="languageOptions"
          :searchable="false"
          :show-labels="false">
          <template slot="option" slot-scope="{ option }">
            {{ option.name }}
          </template>
          <template slot="singleLabel" slot-scope="{ option }">
            <i class="owl-earth mr-8"></i>
            <span class="text-md">{{ option.name }}</span>
          </template>
        </multiSelect>
      </span>
    </div>
    <router-view class="page-container" />
    <div id="footer">
      <div class="footer__wrap container">
        <div class="footer__column">
          <router-link :to="{ name: 'home' }"><img class="logo" style="max-width: 300px;" alt="logo" src="@/assets/logo_2026.svg" @load="logoLoaded"></router-link>
        </div>
        <div class="footer__column">
          <h6 v-t="'language'" class="ml-16">語言</h6>
          <multiSelect
            class="languageSelect"
            v-model="changeLanguage"
            :options="languageOptions"
            :searchable="false"
            :show-labels="false">
            <template slot="option" slot-scope="{ option }">
              {{ option.name }}
            </template>
            <template slot="singleLabel" slot-scope="{ option }">
              <i class="owl-earth mr-8"></i>
              <span class="text-md">{{ option.name }}</span>
            </template>
          </multiSelect>
        </div>
        <!-- <div class="footer__column">
          <h6 v-t="'aboutUs'">關於我們</h6>
          <ul class="footer-list">
            <li><a href="#" target="_blank"><i class="owl-social-fb-square"></i>Facebook</a></li>
            <li><a href="https://www.youtube.com/channel/UCK5e8EWsC1z-bt_qe34vSkA" target="_blank"><i class="owl-format-mail"></i>Youtube</a></li>
          </ul>
        </div> -->
        <div class="footer__column">
          <h6 v-t="'nav.contactUs'">洽詢服務</h6>
          <ul class="footer-list">
            <li><a href="tel:+886-2-6610-0180" terget="_blank"><i class="owl-phone"></i>+886-2-6610-0180</a></li>
            <li><a href="mailto:obs_contact@owlting.com" target="_blank"><i class="owl-format-mail"></i>obs_contact@owlting.com</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="bg-indigo-darkest text-left text-grey text-sm p-16 border-t border-grey-darkest">
      <div class="container">
        <div>Copyright © 2019 OWLTING</div>
      </div>
    </div>
    <div v-if="isContactForm" class="model-mask" @click="cancelContactForm"></div>
    <div v-if="isContactForm" class="contactForm" ref="contactForm">
      <div class="header text-right">
        <div class="close-btn" @click="cancelContactForm"><i class="owl-status-error"></i></div>
      </div>
      <div class="body">
        <h2 class="text-center font-bold px-16">{{ $t('form.title') }}</h2>
        <div class="contactForm__info mx-auto">
          <label for="office">
            <div class="title" v-t="'form.companyName'">公司名稱</div>
            <input type="text" :placeholder="$t('form.companyName')" name="office" v-model="form.office" class="input">
          </label>
          <label for="industry">
            <div class="title"><small class="text-red mr-4">*</small>{{ $t('form.industry') }}</div>
            <multiSelect v-model="form.industry"
              v-validate="'required'"
              name="industry"
              :options="industryOptions"
              :allow-empty="false"
              :searchable="false"
              :show-labels="false"
              :showPointer="isTouchDevice ? false : true"
              :placeholder="$t('form.industry')">
              <template slot="option" slot-scope="{ option }">
                {{ option.title | i18n }}
              </template>
              <template slot="singleLabel" slot-scope="{ option }">
                <i class="owl-tag text-grey mr-4" />
                <span class="text-md">{{ option.title | i18n }}</span>
              </template>
            </multiSelect>
            <div class="inValid" v-show="errorBags.has('industry')"><i class="owl-status-triangle-warning"></i>{{ this.errorBags.first('industry') }}</div>
          </label>
          <template v-if="showAgricultureForm">
            <label for="plan">
              <div class="title">{{ $t('form.plan') }}</div>
              <multiSelect v-model="form.plan"
                name="plan"
                :options="planOptions"
                :allow-empty="false"
                :searchable="false"
                :show-labels="false"
                :showPointer="isTouchDevice ? false : true"
                :placeholder="$t('form.plan')">
                <template slot="option" slot-scope="{ option }">
                  {{ $t(`priceTable.Agriculture.enterprise.${option.name}`) }} - $ {{ option.price }}
                </template>
                <template slot="singleLabel" slot-scope="{ option }">
                  <i class="owl-tag text-grey mr-4" />
                  <span class="text-md">{{ $t(`priceTable.Agriculture.enterprise.${option.name}`) }} - $ {{ option.price }}</span>
                </template>
              </multiSelect>
              <!-- <div class="inValid" v-show="errorBags.has('plan')"><i class="owl-status-triangle-warning"></i>{{ this.errorBags.first('plan') }}</div> -->
            </label>
          </template>
          <label for="name">
            <div class="title"><small class="text-red mr-4">*</small>{{ $t('form.name') }}</div>
            <input type="text" :placeholder="$t('form.name')" name="name" v-model="form.name" v-validate="'required'" class="input">
            <div class="inValid" v-show="errorBags.has('name')"><i class="owl-status-triangle-warning"></i>{{ this.errorBags.first('name') }}</div>
          </label>
          <label for="tel">
            <div class="title">{{ $t('form.phone') }}</div>
            <input type="tel" :placeholder="$t('form.phone')" name="tel" v-validate="'numeric'" v-model="form.tel" class="input">
            <div class="inValid" v-show="errorBags.has('tel')"><i class="owl-status-triangle-warning"></i>{{ this.errorBags.first('tel') }}</div>
          </label>
          <label for="email">
            <div class="title"><small class="text-red mr-4">*</small>{{ $t('form.email') }}</div>
            <input type="text" placeholder="Email" name="email" v-model="form.email" v-validate="'required|email'" class="input">
            <div class="inValid" v-show="errorBags.has('email')"><i class="owl-status-triangle-warning"></i>{{ this.errorBags.first('email') }}</div>
          </label>
          <label for="description">
            <div class="title" v-t="'form.description'">需求/用途描述</div>
            <textarea name="description" v-model="form.description" id="" cols="30" rows="6"></textarea>
          </label>
          <button class="btn btn-solid btn-block btn-blue mt-16 mb-32" @click="submitFormBtn" v-t="'submit'">送出</button>
        </div>
      </div>
    </div>
    <div v-show="isGoToTopShow" id="go-to-top" @click="goToTop"></div>
    <CookieNotification />
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import CookieNotification from '@/components/CookieNotification'
export default {
  name: 'app',
  components: {
    CookieNotification
  },
  data () {
    return {
      languageOptions: [
        {
          name: '中文',
          value: 'zh-TW'
        },
        {
          name: 'English',
          value: 'en'
        },
        {
          name: '日本語',
          value: 'jp'
        }
      ],
      isMenu: false,
      menuTop: 0,
      menuLeft: 0,
      screenWidth: window.innerWidth,
      isGoToTopShow: false,
      form: {
        office: '',
        industry: '',
        name: '',
        tel: '',
        email: '',
        description: '',
        plan: null
      },
      showAgricultureForm: false
    }
  },
  computed: {
    ...mapGetters([
      'lang',
      'routerNames',
      'industries',
      'plans',
      'activeIndustries',
      'isContactForm',
      'hasAgreeCookie',
      'formSelected'
    ]),
    industryOptions: function () {
      return [
        ...this.activeIndustries,
        {
          routername: {
            name: 'Others'
          },
          name: '其他產業'
        }
      ]
    },
    planOptions: function () {
      return [
        ...this.plans
      ]
    },
    changeLanguage: {
      get: function () {
        return _.find(this.languageOptions, lang => lang.value === this.lang)
      },
      set: function (lang) {
        this.setLanguage(lang.value)
        this.$router.replace({
          query: {
            lang: lang.value
          }
        })
        this.$validator.locale = lang.value
      }
    },
    isTouchDevice: function () {
      return this.screenWidth < 768
    },
    menuPosition: function () {
      return {
        top: this.menuTop,
        left: this.isTouchDevice ? 0 : this.menuLeft,
        width: this.isTouchDevice ? '100%' : '300px'
      }
    }
  },
  methods: {
    ...mapMutations([
      'SET_COOKIE'
    ]),
    ...mapActions([
      'i18n',
      'fetchRouterNames',
      'fetchIndustries',
      'openContactForm',
      'cancelContactForm',
      'submitContactForm',
      'setLanguage'
    ]),
    logoLoaded: function () {
      this.menuTop = this.$refs.navWrap.clientHeight + 'px'
      this.menuLeft = this.$refs.nav_menu_btn.offsetLeft - 30 + 'px'
    },
    menuOpenHandler: function (event) {
      this.isMenu = true
    },
    menuCloseHandler: function (event) {
      this.isMenu = false
    },
    submitFormBtn: async function () {
      this.$validator.validate().then(valid => {
        if (!valid) {
          return false
        } else {
          this.submitContactForm(this.form).then(res => {
            if (res.status === 200) {
              this.$swal({
                title: this.$t('submitSuccess'),
                icon: 'success'
              })
            }
          })
        }
      })
    },
    goToTop: function goToTop () {
      // const c = document.documentElement.scrollTop || document.body.scrollTop
      // if (c > 0) {
      //   window.requestAnimationFrame(goToTop)
      //   window.scrollTo(0, c - c / 20)
      // }
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  },
  created () {
    if (this.$route.query.lang) {
      this.setLanguage(this.$route.query.lang)
    } else {
      this.setLanguage('en')
    }
  },
  mounted () {
    this.fetchRouterNames()
    this.fetchIndustries()
    window.addEventListener('resize', e => {
      this.menuTop = this.$refs.navWrap.clientHeight + 'px'
      this.menuLeft = this.$refs.nav_menu_btn.offsetLeft - 30 + 'px'
      this.screenWidth = e.target.innerWidth
    })
    window.addEventListener('scroll', e => {
      const windowOffsetTop = window.pageYOffset
      const bodyHeight = document.body.scrollHeight

      this.isGoToTopShow = bodyHeight - windowOffsetTop <= (bodyHeight / 3) * 2
    })

    // check cookie
    const hasAgreeCookie = document.cookie.includes('owltingOBS-agree-cookie')
    if (hasAgreeCookie) {
      this.SET_COOKIE()
    }
  },
  watch: {
    formSelected: {
      handler: function (val, oldVal) {
        console.log('formSelected', val, oldVal)
        if (val.from === 'Agriculture') {
          this.form.industry = _.find(this.industryOptions, option => option.name === '農業生產')
          // this.showAgricultureForm = true
        }
        if (val.plan) {
          this.form.plan = _.find(this.planOptions, plan => plan.name === val.plan)
        }
      },
      deep: true
    },
    'form.industry': function (val) {
      if (val.name === '農業生產') {
        // this.showAgricultureForm = true
      } else {
        this.showAgricultureForm = false
      }
    },
    '$route.query.lang': {
      handler (val) {
        const langList = this.languageOptions.map(lang => lang.value)
        if (langList.includes(val)) {
          this.$i18n.lang = val
          this.setLanguage(val)
        }
      }
    }
  }
}
</script>

<style lang="sass">
#app
  @apply text-grey-darker antialiased
h1, h2
  @apply text-grey-darkest
#nav
  @apply bg-indigo-darkest p-8 flex flex-wrap border-b border-grey-darkest justify-center fixed w-full
  z-index: 9
  .logo
    @apply flex-no-grow flex-no-shrink mb-8
    max-width: 280px
    @screen md
      @apply mb-0 mr-16
  .nav-wrap
    @apply flex flex-wrap flex-auto flex-row-reverse
    @apply justify-start #{!important}
    @screen md
      @apply flex-row
      @apply justify-between #{!important}
  div[class*='nav']:not([class*='nav__menu'])
    @apply flex items-center justify-center
    @screen md
      @apply ml-16 justify-between
    .link
      @apply text-white no-underline inline-block p-8 rounded ease mx-4 cursor-pointer
      &:hover, &.actived
        @apply bg-white text-indigo-darker font-bold
.gradient-btn
  background: linear-gradient(35deg, #078ABC, #24D4F6) !important
#footer
  @apply bg-indigo-darkest flex flex-wrap text-white pt-16
  .footer__wrap
    @apply flex flex-wrap mx-auto
  .footer__column
    @apply p-16
    @screen md
      @apply flex-1
    h6
      @apply mb-16
    ul.footer-list
      @apply list-reset
      li
        @apply py-8
        // select
        //   @apply bg-indigo-darkest text-white
        //   min-width: 80px
        a
          @apply text-white no-underline
        i
          @apply text-lg inline-block mr-4
          // display: none
          // @screen md
          //   display: inline-block

.hero
  @apply flex flex-wrap
  @screen lg
    @apply flex-no-wrap
  &__cover
    @apply flex-auto bg-cover bg-center bg-no-repeat bg-indigo-darkest flex-no-shrink
    padding-top: imageRatio(849, 442)
    // width: 849px
    width: 55%
    max-width: 100%
    @screen xl
      padding-top: imageRatio(1440, 442)
  &__content
    @apply flex flex-auto p-32 items-center bg-indigo-darkest text-white
    &__wrap
      h1
        @apply mb-24 text-white
      p
        @apply leading-loose mb-48
        // max-width: 400px
  &--home__btn__wrap .btn
    @apply w-full
    @screen sm
      @apply w-auto

.belt
  @apply py-48
  .container
    @apply flex flex-wrap flex-col-reverse
    @screen md
      @apply flex-row
  &__left
    @apply text-center
    @screen md
      @apply text-left
      @apply flex-1
    h2
      @apply mb-24
    p
      @apply leading-loose mb-64
    a, .btn-cta
      .btn
        @apply text-center
        @apply p-16
    a + a, a + .btn-cta, .btn-cta + a, .btn-cta + .btn-cta
      @apply ml-16 flex-auto
      @screen md
        @apply flex-initial
      .btn
        @apply w-full
        @screen md
          @apply w-auto
    .belt-btn-rwd
      @apply mx-auto
      @screen md
        @apply mx-0
  &__right
    @screen md
      @apply flex-1
    img
      @apply mx-auto mb-16 block
      max-width: 60%
      @screen md
        max-width: 100%
.videoWrapper
  position: relative
  padding-bottom: 56.25%
  padding-top: 25px
  height: 0

.videoWrapper iframe
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%

.nav__menu
  @apply text-white cursor-pointer ease px-8
  &:hover
    @apply text-blue-light
  &.active
    @apply text-blue-light
  &__list
    @apply absolute list-reset bg-indigo-darkest border-t-3 border-blue-light flex flex-wrap pt-8 shadow-lg rounded-b ease
    width: 100vw
    top: 0
    left: 0
    z-index: 10
    @screen md
      min-width: 300px
      max-width: 100%
    &__item
      @apply w-1/2 flex-auto
      a
        @apply p-16 text-left text-white w-full inline-block ease
        &:hover:not([disabled])
          @apply bg-blue-light text-indigo-darkest
        &.router-link-active
          @apply text-blue-light
        &[disabled]
          @apply hidden text-grey-darker cursor-not-allowed #{!important}
.model-mask
  @apply fixed bg-black opacity-75 z-10
  top: 0
  left: 0
  width: 100%
  height: 100vh
.contactForm
  @apply fixed bg-white rounded shadow overflow-auto z-10
  max-height: 85vh
  max-width: 480px
  width: 100%
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  .close-btn
    @apply text-grey-dark text-xl p-4 m-4 cursor-pointer rounded ease inline-block
    &:hover
      @apply bg-blue-light text-white
  &__info
    @apply mt-24 px-48
    label
      @apply mb-24 block
      div
        @apply mb-8 text-grey-darker
      input
        @apply w-full
    textarea
      @apply bg-grey-lightest rounded resize-none w-full border border-transparent py-8 px-16
      &:focus
        @apply outline-none bg-white border-grey-light
  .inValid
    @apply text-xs text-red mt-8

.multiselect.languageSelect
  .multiselect__input:focus
    @apply bg-transparent
  .multiselect__select:before
    @apply text-white border-white
    border:
      right-color: transparent
      bottom-color: transparent
      left-color: transparent
  .multiselect__tags
    min-height: 36px
    @apply bg-transparent border-none rounded text-white
  .multiselect__option
    min-height: 36px
  .multiselect__placeholder
    @apply text-white mb-8
  &.multiselect--active
    @apply bg-indigo-darker rounded-t
    &.multiselect--above
      @apply bg-indigo-darker rounded-b
  .multiselect__single
    @apply bg-transparent
  .multiselect__element, .multiselect__content
    @apply border-none
  .multiselect__content-wrapper
    @apply bg-indigo-darker shadow border-none
  .multiselect__option
    @apply text-white
  .multiselect__option--selected
    @apply bg-blue-light text-white
  .multiselect__option--highlight
    @apply bg-indigo-darker text-white
    &.multiselect__option--selected
      @apply bg-blue-light text-white

#go-to-top
  @apply fixed bg-cover bg-center bg-no-repeat cursor-pointer
  background-image: url('assets/go-to-top.png')
  z-index: 9
  bottom: 20px
  right: 10px
  width: 50px
  height: 50px
  @screen md
    right: 50px

.page-container
  padding-top: 24px
  @screen md
    padding-top: 57px
</style>
